import { Toaster } from "react-hot-toast";
import { Routers } from "./routes";

function App() {
  return (
    <>
      <Toaster />
      <Routers />
    </>
  );
}

export default App;
